export default [
    "Default",
    "WithHeader"
];